import { apiClient } from 'pobble-components/dist/api'

export const apiDeleteWork = id => apiClient.delete(`/v3/works/${id}/`)

export const apiUpdateWork = (id, data) =>
  apiClient.put(`/v3/works/${id}`, data)
